import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    BulbMessage,
    PayoutRules,
    AcceptChanges,
    AcceptOfferBtn,
    PlaceButtons,
    LogInToPlaceBet,
} from './BetslipButtonsElements';
import { BetButtonsWrapper } from './BetSlipButtons.style';
import { BetslipFooter } from 'src/domains/sportsbook/betting/ui/betSlip/betslipFooter/BetslipFooter';
import { useAppStateContext } from 'src/appState/AppState';
import { useCommon } from 'src/domains/common/Common';
import { AlertBannerInline } from 'src/domains/layouts/webview/components/alertBanner/Inline';

const BetSlipButtonsInner = observer('BetSlipButtonsInner', () => {
    const {
        appSportsBookState: { betSlipState },
    } = useAppStateContext();
    const common = useCommon();
    const { session } = common;

    if (session.isAuthorized) {
        if (betSlipState.betSlipSummaryState.isLegsChangedWarning) {
            return <AcceptChanges />;
        } else if (betSlipState.referralState.isBetSlipOffer) {
            return <AcceptOfferBtn />;
        } else {
            return <PlaceButtons />;
        }
    } else {
        return <LogInToPlaceBet />;
    }
});

export const BetSlipButtons = observer('BetSlipButtons', () => {
    const { appSportsBookState, common } = useAppStateContext();
    const { betSlipState } = appSportsBookState;

    const { isRejectedBet } = betSlipState.referralState;
    const { isShowQuickBet } = betSlipState.basicBetSlipState;
    const { isVisibleKeyBoard, focusedSelectionId } = betSlipState.basicBetSlipState;
    const showFreeBetButton =
        !common.features.bonusEngine &&
        betSlipState.freeBetsAmount !== null &&
        betSlipState.freeBetsAmount.isGreaterThanZero();

    if (isRejectedBet) {
        return null;
    }

    if (isShowQuickBet) {
        return (
            <>
                <BetButtonsWrapper visibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}>
                    <BetSlipButtonsInner />
                    <AlertBannerInline
                        marginTop='8px'
                        marginBottom='8px'
                        message={<PayoutRules />}
                        size='small'
                    />
                </BetButtonsWrapper>
                {showFreeBetButton ? <BulbMessage /> : null}
            </>
        );
    }

    return (
        <BetButtonsWrapper visibleKeyboard={isVisibleKeyBoard && focusedSelectionId !== null}>
            <BetSlipButtonsInner />
            <AlertBannerInline
                marginBottom='8px'
                message={<PayoutRules />}
                size='small'
            />
            <BetslipFooter />
            {showFreeBetButton ? <BulbMessage /> : null}
        </BetButtonsWrapper>
    );
});
